import { api } from "./client.js";
import type { DashboardData, CommunityStats } from "@wwrp/shared";

export const dashboardApi = {
  activity: () => api.get<CommunityStats | null>("/dashboard/activity"),
  get: () => api.get<DashboardData>("/dashboard"),
};
